import { Type } from 'class-transformer';
import { ConveyanceAssessmentRuleResultDto } from './conveyance-assessment-rule-result-dto';
import { ConveyanceBillingRuleResultDto } from './conveyance-billing-rule-result-dto';

export class ConveyanceCommunityAssessmentRuleResultDto {
    billingMode: string;
    communityId: number;
    communityName: string;

    @Type(() => ConveyanceAssessmentRuleResultDto)
    regularAssessmentRules: ConveyanceAssessmentRuleResultDto[];

    @Type(() => ConveyanceAssessmentRuleResultDto)
    specialAssessmentRules: ConveyanceAssessmentRuleResultDto[];

    currentSellerRegularAssessmentDisplayText: string;
    currentSellerSpecialAssessmentDisplayText: string;

    @Type(() => ConveyanceBillingRuleResultDto)
    billingRules: ConveyanceBillingRuleResultDto[];
}
